var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeNetwork(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 424,
    height: 169,
    viewBox: "0 0 424 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36568_38850)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 126.154,
    y1: 77.7358,
    x2: 131.916,
    y2: 141.111,
    stroke: "#8797AB",
    strokeWidth: 0.960227
  }), /*#__PURE__*/React.createElement("line", {
    x1: 188.122,
    y1: 137.792,
    x2: 131.469,
    y2: 141.633,
    stroke: "#8797AB",
    strokeWidth: 0.960227
  }), /*#__PURE__*/React.createElement("line", {
    x1: 310.177,
    y1: 100.352,
    x2: 287.82,
    y2: 137.753,
    stroke: "#8797AB",
    strokeWidth: 0.960227
  }), /*#__PURE__*/React.createElement("line", {
    x1: 277.867,
    y1: 17.5514,
    x2: 310.205,
    y2: 92.2324,
    stroke: "#8797AB",
    strokeWidth: 0.960227
  }), /*#__PURE__*/React.createElement("line", {
    x1: 313.085,
    y1: 96.0284,
    x2: 371.667,
    y2: 118.62,
    stroke: "#8797AB",
    strokeWidth: 0.960227
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.6414,
    y1: 103.279,
    x2: 131.658,
    y2: 140.728,
    stroke: "#8797AB",
    strokeWidth: 0.960227
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.955,
    y1: 28.3542,
    x2: 179.609,
    y2: 48.519,
    stroke: "#8797AB",
    strokeWidth: 0.960227
  }), /*#__PURE__*/React.createElement("line", {
    x1: 172.239,
    y1: 7.59395,
    x2: 179.921,
    y2: 48.8837,
    stroke: "#8797AB",
    strokeWidth: 0.960227
  }), /*#__PURE__*/React.createElement("line", {
    x1: 204.987,
    y1: 84.7833,
    x2: 179.061,
    y2: 49.2548,
    stroke: "#8797AB",
    strokeWidth: 0.960227
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.636 335.599C303.71 335.599 378.35 260.959 378.35 168.885C378.35 76.8106 303.71 2.16992 211.636 2.16992C119.562 2.16992 44.9209 76.8106 44.9209 168.885C44.9209 260.959 119.562 335.599 211.636 335.599Z",
    stroke: "#E5E5EE",
    strokeWidth: 1.35392,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.636 293.608C280.519 293.608 336.359 237.767 336.359 168.884C336.359 100.001 280.519 44.1602 211.636 44.1602C142.752 44.1602 86.9116 100.001 86.9116 168.884C86.9116 237.767 142.752 293.608 211.636 293.608Z",
    stroke: "#E5E5EE",
    strokeWidth: 1.35392,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.636 251.619C257.328 251.619 294.369 214.578 294.369 168.886C294.369 123.193 257.328 86.1523 211.636 86.1523C165.943 86.1523 128.902 123.193 128.902 168.886C128.902 214.578 165.943 251.619 211.636 251.619Z",
    stroke: "#E5E5EE",
    strokeWidth: 1.35392,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.635 209.637C234.142 209.637 252.387 191.391 252.387 168.885C252.387 146.378 234.142 128.133 211.635 128.133C189.129 128.133 170.883 146.378 170.883 168.885C170.883 191.391 189.129 209.637 211.635 209.637Z",
    stroke: "#E5E5EE",
    strokeWidth: 1.35392,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1423 107.056C60.5287 107.056 62.4633 105.122 62.4633 102.735C62.4633 100.349 60.5287 98.4141 58.1423 98.4141C55.7559 98.4141 53.8213 100.349 53.8213 102.735C53.8213 105.122 55.7559 107.056 58.1423 107.056Z",
    fill: "#A480FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.421 20.8393C280.807 20.8393 282.742 18.9047 282.742 16.5183C282.742 14.1319 280.807 12.1973 278.421 12.1973C276.034 12.1973 274.1 14.1319 274.1 16.5183C274.1 18.9047 276.034 20.8393 278.421 20.8393Z",
    fill: "#A480FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.815 90.2607C208.672 90.2607 210.176 88.756 210.176 86.8999C210.176 85.0437 208.672 83.5391 206.815 83.5391C204.959 83.5391 203.455 85.0437 203.455 86.8999C203.455 88.756 204.959 90.2607 206.815 90.2607Z",
    fill: "#A480FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.315 30.7276C124.172 30.7276 125.676 29.2229 125.676 27.3668C125.676 25.5107 124.172 24.006 122.315 24.006C120.459 24.006 118.955 25.5107 118.955 27.3668C118.955 29.2229 120.459 30.7276 122.315 30.7276Z",
    fill: "#A480FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.247 14.4034C176.224 14.4034 179.448 11.1791 179.448 7.2017C179.448 3.22431 176.224 0 172.247 0C168.269 0 165.045 3.22431 165.045 7.2017C165.045 11.1791 168.269 14.4034 172.247 14.4034Z",
    fill: "#A480FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.623 141.266C289.58 141.266 291.166 139.68 291.166 137.723C291.166 135.766 289.58 134.18 287.623 134.18C285.666 134.18 284.08 135.766 284.08 137.723C284.08 139.68 285.666 141.266 287.623 141.266Z",
    fill: "#A480FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.61 141.154C189.997 141.154 191.931 139.219 191.931 136.832C191.931 134.446 189.997 132.511 187.61 132.511C185.224 132.511 183.289 134.446 183.289 136.832C183.289 139.219 185.224 141.154 187.61 141.154Z",
    fill: "#A480FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.014 125.79C374.991 125.79 378.215 122.566 378.215 118.588C378.215 114.611 374.991 111.387 371.014 111.387C367.036 111.387 363.812 114.611 363.812 118.588C363.812 122.566 367.036 125.79 371.014 125.79Z",
    fill: "#A480FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.156 82.5793C128.542 82.5793 130.477 80.6447 130.477 78.2583C130.477 75.8718 128.542 73.9373 126.156 73.9373C123.77 73.9373 121.835 75.8718 121.835 78.2583C121.835 80.6447 123.77 82.5793 126.156 82.5793Z",
    fill: "#A480FF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_36568_38850)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 133.46,
    cy: 137.415,
    r: 22.188,
    fill: "#8A75F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.439 160.065C115.513 163.627 116.026 168.522 120.035 169.808C121.185 170.083 122.379 170.111 123.541 169.892C124.593 169.804 125.65 169.98 126.617 170.405C128.79 171.263 130.738 172.326 133.144 172.4C135.474 172.444 137.759 171.749 139.67 170.414C140.35 169.957 141.367 168.988 142.271 169.081C143.175 169.174 143.959 170.013 144.751 170.33C149.59 172.279 151.678 166.415 152.042 162.769C152.862 154.378 148.313 146.071 142.402 140.393V140.328C142.675 139.61 142.823 138.85 142.84 138.081C142.983 136.981 143.224 135.895 143.558 134.837C144.154 133.112 145.618 131.835 146.606 130.334C147.521 129.013 147.968 127.425 147.874 125.821C147.845 125.1 147.653 124.394 147.314 123.757C146.975 123.12 146.498 122.566 145.916 122.138C144.518 121.206 142.756 121.337 141.143 121.309C137.815 121.253 134.262 120.88 130.999 121.7C129.443 122.079 128.013 122.859 126.853 123.963C125.693 125.068 124.843 126.458 124.389 127.993C123.457 130.93 123.047 134.995 124.296 137.876L123.895 138.128C122.97 138.737 122.111 139.44 121.331 140.226C119.896 141.739 118.723 143.481 117.863 145.381C115.765 150.006 115.373 155.078 115.439 160.065Z",
    fill: "#F0F0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.286 131.387C140.286 131.387 141.703 141.642 137.032 143.181C133.302 144.411 129.489 141.185 128.501 134.631",
    stroke: "#00005A",
    strokeWidth: 1.04006,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.834 172.409C122.834 172.409 115.198 149.203 128.483 143.189",
    stroke: "#00005A",
    strokeWidth: 1.04006,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.703 144.887C145.843 147.516 150.849 154.21 148.024 171.356",
    stroke: "#00005A",
    strokeWidth: 1.04006,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.95 159.142C143.95 159.142 145.814 169.398 133.694 169.398C130.039 169.398 127.046 169.099 125.946 157.277",
    stroke: "#00005A",
    strokeWidth: 1.04006,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.664 137.428C125.498 136.277 124.744 134.773 124.518 133.151C124.293 131.528 124.607 129.876 125.414 128.45C124.697 128.249 124.052 127.849 123.554 127.296C123.056 126.742 122.726 126.059 122.602 125.325C122.478 124.591 122.565 123.836 122.853 123.15C123.142 122.464 123.619 121.873 124.23 121.448C128.295 118.651 130.113 125.457 130.113 125.457C135.586 121.43 140.984 122.753 140.509 126.958C139.865 132.701 131.362 130.268 131.362 130.268C131.108 130.95 130.649 131.537 130.048 131.947C129.447 132.358 128.734 132.573 128.006 132.562",
    stroke: "#00005A",
    strokeWidth: 1.04006,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_36568_38850)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 182.912,
    cy: 48.5945,
    r: 14.0261,
    fill: "#FF9F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.52 62.9121C171.567 65.1635 171.892 68.2577 174.426 69.071C175.153 69.2446 175.908 69.2626 176.642 69.1241C177.307 69.0685 177.976 69.1799 178.587 69.4482C179.96 69.9904 181.192 70.6623 182.712 70.7095C184.186 70.7375 185.63 70.298 186.838 69.4541C187.268 69.1653 187.911 68.5524 188.482 68.6113C189.054 68.6702 189.549 69.2007 190.05 69.4011C193.109 70.6328 194.429 66.9257 194.659 64.6213C195.177 59.317 192.301 54.0657 188.565 50.4765V50.4352C188.738 49.9811 188.831 49.5007 188.842 49.0148C188.933 48.3192 189.084 47.6329 189.296 46.9639C189.673 45.8735 190.598 45.0661 191.223 44.1172C191.801 43.2826 192.083 42.2784 192.024 41.2647C192.006 40.8087 191.885 40.3628 191.67 39.9599C191.456 39.5569 191.154 39.2073 190.787 38.9367C189.903 38.3473 188.789 38.4298 187.769 38.4121C185.665 38.3768 183.42 38.141 181.357 38.6597C180.373 38.8988 179.469 39.3922 178.736 40.0903C178.003 40.7885 177.465 41.667 177.178 42.6379C176.589 44.4944 176.33 47.064 177.119 48.8852L176.866 49.0443C176.281 49.4292 175.738 49.8736 175.245 50.3704C174.338 51.3269 173.597 52.4285 173.053 53.6296C171.727 56.5529 171.479 59.759 171.52 62.9121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.227 44.7832C187.227 44.7832 188.123 51.2662 185.171 52.2387C182.813 53.0167 180.403 50.9775 179.778 46.8342",
    stroke: "#00005A",
    strokeWidth: 0.657473,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.194 70.7149C176.194 70.7149 171.367 56.0456 179.765 52.2441",
    stroke: "#00005A",
    strokeWidth: 0.657473,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.123 53.3164C190.74 54.9784 193.905 59.2101 192.119 70.0485",
    stroke: "#00005A",
    strokeWidth: 0.657473,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.544 62.3291C189.544 62.3291 190.722 68.8122 183.061 68.8122C180.75 68.8122 178.859 68.6236 178.163 61.1504",
    stroke: "#00005A",
    strokeWidth: 0.657473,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.616 48.6025C177.879 47.8745 177.403 46.9242 177.26 45.8984C177.117 44.8726 177.316 43.8283 177.826 42.9269C177.373 42.8001 176.965 42.547 176.65 42.1971C176.336 41.8473 176.127 41.4152 176.048 40.9512C175.97 40.4871 176.025 40.0104 176.207 39.5765C176.39 39.1426 176.691 38.7695 177.078 38.5007C179.647 36.7326 180.797 41.035 180.797 41.035C184.256 38.4889 187.669 39.3258 187.368 41.9839C186.961 45.6144 181.586 44.0761 181.586 44.0761C181.426 44.5073 181.136 44.8782 180.756 45.1378C180.376 45.3974 179.925 45.533 179.465 45.526",
    stroke: "#00005A",
    strokeWidth: 0.657473,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 309.438,
    cy: 96.8012,
    r: 25.0749,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.145 84.5594C306.809 85.1369 306.57 85.7648 306.435 86.4188C309.059 86.8249 312.102 87.1884 314.581 87.4661C314.581 87.4661 316.304 90.505 317.941 90.3364",
    stroke: "#00005A",
    strokeWidth: 0.919282,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.577 85.7512C304.577 85.7512 300.626 99.1356 307.968 101.438C312.983 103.007 316.091 100.607 318.427 92.0536",
    stroke: "#00005A",
    strokeWidth: 0.919282,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.336 99.6989C305.336 99.6989 293.053 102.188 291.67 113.756",
    stroke: "#00005A",
    strokeWidth: 0.919282,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.464 90.9345L308.038 94.7575L309.401 94.9203",
    stroke: "#00005A",
    strokeWidth: 0.919282,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.403 90.8739C307.43 90.6479 307.366 90.4205 307.226 90.2417C307.085 90.0628 306.879 89.9471 306.653 89.9201C306.427 89.8932 306.2 89.957 306.021 90.0977C305.842 90.2384 305.726 90.4443 305.699 90.6703",
    stroke: "#00005A",
    strokeWidth: 0.919282,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.824 91.6395C313.851 91.4135 313.787 91.1861 313.646 91.0073C313.506 90.8284 313.3 90.7128 313.074 90.6858C312.848 90.6588 312.62 90.7227 312.441 90.8633C312.263 91.004 312.147 91.21 312.12 91.4359",
    stroke: "#00005A",
    strokeWidth: 0.919282,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.443 98.3358C321.867 99.2718 322.987 95.6838 322.987 95.6838C320.445 89.3252 320.996 80.1698 311.022 78.9782C300.841 77.7619 297.284 87.7987 297.894 95.8706C299.223 96.3512 300.635 96.5638 302.047 96.4964",
    stroke: "#00005A",
    strokeWidth: 0.919282,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.382 97.6607L310.955 97.1533",
    stroke: "#00005A",
    strokeWidth: 0.919282,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.931 99.864C335.221 95.1585 335.352 90.0882 333.581 85.6365C331.881 81.3782 328.284 77.7452 324.663 75.0412C318.815 70.6762 310.973 68.69 304.238 71.0269C299.7 71.6081 295.102 73.5153 292.266 76.3859C288.622 80.0735 287.752 84.9752 287.921 89.9146C290.749 94.1409 289.703 97.8365 286.641 101.612C285.19 103.42 287.392 107.72 290.652 106.832C292.21 106.401 293.146 104.821 294.344 103.829C296.304 102.24 298.62 101.151 301.093 100.654C303.773 100.079 303.172 95.8597 300.452 96.4112C299.803 96.5696 299.141 96.6661 298.473 96.6994C297.181 96.7179 297.35 96.7504 296.859 95.4881C296.182 93.7655 296.673 91.2626 296.911 89.4704C297.206 87.3058 297.696 85.1725 298.377 83.0968C299.981 81.3661 301.809 79.8575 303.813 78.6111C307.874 77.3249 312.319 77.1585 315.795 78.8515C316.697 79.7246 317.535 80.6642 318.363 81.5901C319.19 82.516 320.034 83.4624 320.817 84.4509C321.638 86.5258 322.349 88.6421 322.948 90.7912C323.499 92.3284 323.902 93.9141 324.154 95.5274C324.358 97.6935 323.752 98.0099 322.094 98.7685C317.942 100.667 321.446 105.789 322.605 108.748C323.192 110.244 323.607 111.831 325.214 112.485C326.82 113.14 328.418 112.473 329.732 111.55C333.5 108.89 334.657 104.22 334.931 99.864Z",
    fill: "#FF44FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.227 107.398C289.683 112.402 293.742 116.44 298.759 118.869C303.776 121.299 309.461 121.979 314.91 120.803C320.358 119.627 325.257 116.661 328.824 112.378C332.392 108.096 334.424 102.742 334.597 97.171C334.769 91.5997 333.073 86.1308 329.777 81.6354C326.481 77.1401 321.776 73.8768 316.411 72.3653C311.046 70.8539 305.329 71.1812 300.172 73.2952C295.014 75.4092 290.712 79.1882 287.951 84.0304",
    stroke: "#00005A",
    strokeWidth: 0.919282,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36568_38850"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 422.5,
    height: 169,
    fill: "white",
    transform: "translate(0.75)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_36568_38850"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.272,
    y: 115.227,
    width: 44.3761,
    height: 44.3761,
    rx: 22.188,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_36568_38850"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.886,
    y: 34.5684,
    width: 28.0522,
    height: 28.0522,
    rx: 14.0261,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeNetwork);
export default __webpack_public_path__ + "static/media/home-network.0c92609e82defd85b658efe3ddef2bbc.svg";
export { ForwardRef as ReactComponent };